import { Friendship, FriendshipWithUser, FriendshipStatus } from '../../domain/models';

// Entity representing the database structure
export interface FriendshipEntity {
  id: string;
  requester_id: string;
  addressee_id: string;
  status: 'pending' | 'accepted' | 'declined';
  created_at: string;
  updated_at: string;
}

export interface FriendshipWithUserEntity extends FriendshipEntity {
  requester_name?: string;
  requester_email?: string;
  requester_avatar_url?: string;
  friend_name?: string;
  friend_email?: string;
  friend_avatar_url?: string;
}

// Mapper: from Entity (DB) to Model (Domain)
export const friendshipEntityToModel = (entity: FriendshipEntity): Friendship => {
  return {
    id: entity.id,
    requesterId: entity.requester_id,
    addresseeId: entity.addressee_id,
    status: entity.status as FriendshipStatus,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

export const friendshipWithUserEntityToModel = (
  entity: FriendshipWithUserEntity
): FriendshipWithUser => {
  return {
    id: entity.id,
    requesterId: entity.requester_id,
    addresseeId: entity.addressee_id,
    status: entity.status as FriendshipStatus,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
    userName: entity.requester_name || entity.friend_name,
    userEmail: entity.requester_email || entity.friend_email,
    userAvatarUrl: entity.requester_avatar_url || entity.friend_avatar_url,
  };
};

// Mapper: from Model (Domain) to Entity (DB)
export const friendshipModelToEntity = (
  model: Partial<Friendship>
): Partial<FriendshipEntity> => {
  return {
    id: model.id,
    requester_id: model.requesterId,
    addressee_id: model.addresseeId,
    status: model.status,
    created_at: model.createdAt?.toISOString(),
    updated_at: model.updatedAt?.toISOString(),
  };
};
